import React from "react";
import { Image, Toast } from "react-bootstrap";
import Draggable from "react-draggable";
import pictureEN from "../../../../images/Aashto/20231009_LRFDBridge Design_EN.png";
import pictureDE from "../../../../images/Aashto/20231009_LRFDBridge Design_DE.png";
import pictureES from "../../../../images/Aashto/20231009_LRFDBridge Design_ES.png";
import { useTranslation } from "react-i18next";

function DesignCombinationDetails({ show, setShow }) {
  const { i18n } = useTranslation("translation");
  const nodeRef = React.useRef(null);
  return (
    <Draggable nodeRef={nodeRef}>
      <Toast
        ref={nodeRef}
        onClose={() => setShow(!show)}
        show={show}
        animation={false}
        style={{
          zIndex: 1000,
          backgroundColor: "white",
          position: "absolute",
          width: "auto",
          height: "auto",
        }}
      >
        <Toast.Header className="d-flex flex-row-reverse"></Toast.Header>
        <Toast.Body>
          <Image
            src={
              i18n.language === "de-DE"
                ? pictureDE
                : i18n.language === "es-ES"
                  ? pictureES
                  : pictureEN
            }
            alt=""
            width={700}
            // style={{ width: "700px" }}
          />
        </Toast.Body>
      </Toast>
    </Draggable>
  );
}

export default DesignCombinationDetails;
